import axios, { AxiosInstance } from "axios";

const BASE_URL = process.env.BASE_URL;

const AxiosClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
});

export const getHologramInfo = async (hologramId: string): Promise<any> =>
  (await AxiosClient.get(`/authinc/hologram/${hologramId}`)).data;